import { Link } from 'react-router-dom';
import { topRated } from '@/mocks/comics';

const rankImages: Record<string, string> = {
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
  'comic-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
  'comic-2': 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20elegant%20CEO%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20white%20dress%20rose%20petals%20scattered%20romantic%20atmosphere%20pink%20cream%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20art%20beautiful%20woman%20in%20traditional%20hanbok%20standing%20in%20ancient%20palace%20garden%20soft%20autumn%20leaves%20golden%20beige%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
  'comic-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
};

export default function RankingSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              排行榜
            </h2>
            <p className="mt-2 text-sm text-foreground-500">读者评分最高的漫画</p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {topRated.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={rankImages[comic.id]}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2 w-7 h-7 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold">
                  {index + 1}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-xs text-background-50/90">
                    <i className="ri-star-fill text-accent-400"></i>
                    <span>{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-0.5">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}